import { FunctionComponent, ReactElement } from 'react';
import { MessageDescriptor } from 'react-intl';

import {
  ButtonLink,
  ButtonProps,
} from '@savgroup-front-common/core/atoms/button';
import {
  SafeFormattedMessage,
  SafeFormattedMessageWithoutSpread,
} from '@savgroup-front-common/core/formatters';
import { MessageType } from '@savgroup-front-common/types';

import { useLayout } from '../NewLayout.hooks';

import Banner from './Banner';
import {
  $Description,
  $HeadingAction,
  $HeadingTitle,
  $HeadingWrapper,
  $Title,
} from './BanneredLayout.styles';
import Breadcrumb, { BreadcrumbItem } from './Breadcrumb/Breadcrumb';

const BannerTitle: FunctionComponent<{
  breadcrumbs?: BreadcrumbItem[];
  title?: string | MessageType | MessageDescriptor;
  description?: string | MessageType | MessageDescriptor;
  actions?: {
    label: string | MessageType | MessageDescriptor;
    route: string;
    icon?: ReactElement;
    props?: ButtonProps;
    primary?: boolean;
  }[];
}> = ({ breadcrumbs, title, description, actions }) => {
  const { enableServicePortal } = useLayout();

  return (
    <Banner>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <$HeadingWrapper>
        <$HeadingTitle>
          {title && (
            <$Title
              $enableServicePortal={enableServicePortal}
              data-testid="pageTitle"
            >
              <SafeFormattedMessageWithoutSpread message={title} />
            </$Title>
          )}
          {description && (
            <$Description
              $enableServicePortal={enableServicePortal}
              data-testid="pageDidactics"
            >
              <SafeFormattedMessageWithoutSpread message={description} />
            </$Description>
          )}
        </$HeadingTitle>
        {actions && (
          <$HeadingAction>
            {actions?.map((action) => (
              <ButtonLink
                key={action.label.toString()}
                icon={action.icon}
                href={action.route}
                primary={action.primary}
                small
              >
                <span>{SafeFormattedMessage(action.label)}</span>
              </ButtonLink>
            ))}
          </$HeadingAction>
        )}
      </$HeadingWrapper>
    </Banner>
  );
};

export default BannerTitle;
